import {
  SplashTypingProps,
  splitSplashBubble,
  splitSplashText,
} from "./SplashTyping";

export const SPLASH_CONTENT: SplashTypingProps["content"] = [
  [...splitSplashText("Rooted in "), ...splitSplashBubble("Real")],
];
